import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import AlertIcon from '../../../../../assets/icons/flows/alert_triangle.svg';
import ViewIcon from '../../../../../assets/icons/forms/views_raw.svg';
import Tooltip from '../../../../../components/ui/Tooltip';
import { setPreviewMode } from '../../../../../store/reducers/forms';
import uniqueId from '../../../../../utils/uniqueId';
import { useInputAlert } from '../../../hooks/useInputAlert';
import styles from './PreviewButton.module.scss';

const PreviewButton = () => {
  const dispatch = useDispatch();
  const tooltipId = uniqueId('preview_button');
  const [checked, setChecked] = useState(false);
  const alert = useInputAlert();

  return (
    <>
      <div className={styles.wrapper} data-for={tooltipId} data-tip>
        <button
          type="button"
          className={`${styles.button} ${checked ? styles.checked : ''}`}
          onClick={() => {
            dispatch(setPreviewMode(!checked));
            setChecked(!checked);
          }}
        >
          <ViewIcon />
        </button>
        {alert && <AlertIcon className={styles.alert} width={20} />}
      </div>
      <Tooltip
        id={tooltipId}
        info={
          alert
            ? 'Field colors may reduce readability — preview with sample text'
            : 'Preview filled form'
        }
      />
    </>
  );
};

export default PreviewButton;
